import { useFirestoreManager } from '../../redux/store';

const FirestoreManager = () => {
  useFirestoreManager();

  return <></>;
};

export default FirestoreManager;
